// Mirrors backend generate_repayment_schedule
export const computeLoanSchedule = (principal, rate, term, interestType, repaymentMode, ratePeriod) => {
  let method = interestType === 'compound' ? 'compound' : 'simple';
  let period = ratePeriod || 'annual';
  if (interestType === 'fixed_amount') method = 'fixed';
  if (interestType === 'monthly_percentage') period = 'monthly';
  if (interestType === 'annual_percentage') period = 'annual';
  const r = method === 'fixed' ? rate : (period === 'monthly' ? rate / 100 : rate / 100 / 12);
  const interestOnly = repaymentMode === 'interest_only';
  const emi = method === 'compound' && !interestOnly
    ? (r > 0 ? principal * r * Math.pow(1 + r, term) / (Math.pow(1 + r, term) - 1) : principal / term)
    : null;
  const rows = [];
  let balance = principal;
  for (let m = 1; m <= term; m++) {
    const last = m === term;
    const interest = method === 'fixed' ? r : (method === 'simple' || interestOnly ? principal * r : balance * r);
    let p;
    if (interestOnly) p = last ? principal : 0;
    else if (emi !== null) p = last ? balance : emi - interest;
    else p = last ? balance : Math.round((principal / term) * 100) / 100;
    balance -= p;
    rows.push({ month: m, principal: p, interest, total: p + interest });
  }
  return rows;
};

export const describeLoanRate = (loan, sym) => {
  const t = loan.interest_type;
  if (t === 'fixed_amount') return `${sym}${loan.interest_rate}/mo fixed`;
  if (t === 'monthly_percentage') return `${loan.interest_rate}%/mo simple`;
  if (t === 'annual_percentage') return `${loan.interest_rate}%/yr simple`;
  const per = (loan.rate_period || 'annual') === 'monthly' ? 'mo' : 'yr';
  return `${loan.interest_rate}%/${per} ${t}`;
};
